import { RootState } from 'app/store'
import { createSelector } from '@reduxjs/toolkit'
import UserRole from 'enums/UserRole'

export const selectSuggestedUserList = (state: RootState) => state.suggestedUserList.data

export const selectScheduledReportSuggestedUserList = createSelector(
  [selectSuggestedUserList, (_: RootState, subscribers: any[]) => subscribers],
  (suggestedUserList, subscribers) => {
    const transformedSuggestedUserList = suggestedUserList
      .filter(
        (user) =>
          // * not in subscribers list
          !subscribers.some((subscriber) => subscriber.userProfileId === user.userProfileId) &&
          // * not an annotator
          user.userRole !== UserRole.ROLE_ANNOTATOR
      )
      .map((user) => ({
        ...user,
        label: `${user.userName} (${user.email})`,
        id: user.userProfileId
      }))
    return transformedSuggestedUserList
  }
)

export const selectCurrentUser = createSelector(
  [selectSuggestedUserList, (state: RootState) => state.pageConfig.config.user.email],
  (suggestedUserList, userEmail) => {
    const currentUser = suggestedUserList.find((user) => user.email === userEmail)
    if (!currentUser) return undefined
    return {
      ...currentUser,
      label: `${currentUser.userName} (${currentUser.email})`,
      id: currentUser.userProfileId
    }
  }
)

export const selectSubscriptionUsers = createSelector(
  [
    selectSuggestedUserList,
    (state: RootState) => state.scheduledReport.reportInfo.data?.subscriptions || []
  ],
  (suggestedUserList, subscribers) => {
    const transformedSuggestedUserList = suggestedUserList
      .filter((user) =>
        subscribers.some((subscriber) => subscriber.subscriberId === user.userProfileId)
      )
      .map((user) => ({
        ...user,
        label: `${user.userName} (${user.email})`,
        id: user.userProfileId
      }))
    return transformedSuggestedUserList
  }
)
